import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage.jsx";
import OTPVerification from "./pages/OTPVerification.jsx";

import "../src/style.css";
import LoginPage from "./pages/LoginPage.jsx";
import ForgetPasswordPage from "./pages/ForgetPasswordPage.jsx";
import ResetPasswordpage from "./pages/ResetPasswordpage.jsx";
import SignUpPage from "./pages/SignUpPage.jsx";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AuthCallback from "./component/VendorDashboard/AuthGoogle/AuthCallback.jsx";
// import Loading from "./component/sharedComponents/Loading/Loading.jsx";
import LoadingOverlay from "./component/sharedComponents/Loading/LoadingOverlay.jsx";
import useGlobalLoading from "./component/sharedComponents/Loading/useGlobalLoading.jsx";
import ScrollToTop from "./component/sharedComponents/ScrollToTop.jsx";
import MainLayout from "./component/layers/Layout/MainLayout.jsx";
import TrendingPage from "./pages/TrendingPage.jsx";
import MessagesPage from "./pages/MessagesPage.jsx";
import SavedPage from "./pages/SavedPage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import AuthCallback from "./component/Register/AuthGoogle/AuthCallback.jsx";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { getMyProfile } from "./slices/1-auth/2-myProfile/thunk.js";
import EditProfilePage from "./pages/EditProfilePage.jsx";
import ProtectedRoute from "./component/layers/Layout/ProtectedRoute.jsx";
import AdminProtectedRoute from "./component/layers/Layout/AdminProtectedRoute.jsx";
import SinglePost from "./pages/SinglePost.jsx";
import SettingsPostPage from "./pages/SettingAdmin/SettingsPostPage.jsx";
import SettingsUserPage from "./pages/SettingAdmin/SettingsUserPage.jsx";
import SettingsCompanyPage from "./pages/SettingAdmin/SettingsCompanyPage.jsx";
import AnotherProfilePage from "./pages/AnotherProfilePage.jsx";
import CompanyProfilePage from "./pages/CompanyProfilePage.jsx";
import SettingsReviewPage from "./pages/SettingAdmin/SettingsReviewPage.jsx";
import CompanyAnotherProfilePage from "./pages/CompanyAnotherProfilePage.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsAndConditions from "./pages/TermsAndConditions.jsx";
import AboutUs from "./pages/AboutUs.jsx";
import ContactUsPage from "./pages/ContactUsPage.jsx";
import SettingsContactPage from "./pages/SettingAdmin/SettingsContactPage.jsx";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [minTimeDone, setMinTimeDone] = useState(false);
  const globalLoading = useGlobalLoading();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.myProfile);
  useEffect(() => {
    dispatch(getMyProfile());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeDone(true), 1000);
    return () => clearTimeout(timer);
  }, []);
  // console.log(profile);
  const showLoader = globalLoading && !minTimeDone;
  return (
    <div className="App dark:bg-bg-dark-primary bg-bg-light-primary dark:text-gray-100">
      <LoadingOverlay show={showLoader} />

      <Router>
        <ScrollToTop />

        <Routes>
          {/* Layout  */}
          <Route element={<MainLayout />}>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trending"
              element={
                <ProtectedRoute>
                  <TrendingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/messages"
              element={
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/saved"
              element={
                <ProtectedRoute>
                  <SavedPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/post/:id"
              element={
                <ProtectedRoute>
                  <SinglePost />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/mycompany"
              element={
                <ProtectedRoute>
                  <CompanyProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile-company/:slug"
              element={
                <ProtectedRoute>
                  <CompanyAnotherProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/edit"
              element={
                <ProtectedRoute>
                  <EditProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/:code"
              element={
                <ProtectedRoute>
                  <AnotherProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings/posts"
              element={
                <AdminProtectedRoute>
                  <SettingsPostPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/settings/companies"
              element={
                <AdminProtectedRoute>
                  <SettingsCompanyPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/settings/reviews"
              element={
                <AdminProtectedRoute>
                  <SettingsReviewPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/settings/users"
              element={
                <AdminProtectedRoute>
                  <SettingsUserPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/settings/contact"
              element={
                <AdminProtectedRoute>
                  <SettingsContactPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <AdminProtectedRoute>
                  {/* <AdminDashboard /> */}
                </AdminProtectedRoute>
              }
            />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms-condition" element={<TermsAndConditions />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="contact" element={<ContactUsPage />} />
          </Route>

          <Route path="login" element={<LoginPage />} />
          <Route path="forget-password" element={<ForgetPasswordPage />} />
          <Route path="otp" element={<OTPVerification />} />
          <Route path="reset-password" element={<ResetPasswordpage />} />
          <Route path="sign-up" element={<SignUpPage />} />

          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </Router>

      {/* Toast */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default App;
